

import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Path } from "./routes";
import ProtectedRoute from "../store/ProtectedRoute";
import AdminProtectedRoute from "../store/AdminProtectedRoute";
//import ProtectedRoute from "../store/ProtectedRoute";


const NotFound = lazy(() => import("../pages/404"));
const Home = lazy(() => import("../pages/home"));
const Landing = lazy(() => import("../pages/landing"));
const AcceptAssignment = lazy(() => import("../pages/user/secure"));

const DealRoom = lazy(() => import("../pages/user/dealroom"));
const DealRoomDetail = lazy(() => import("../pages/user/dealroom/Detail"));
const Landlord = lazy(() => import("../pages/landing/LandlordLanding"));
const Lawyer = lazy(() => import("../pages/landing/Lawyer"));
const Agent = lazy(() => import("../pages/landing"));
const Realtor = lazy(() => import("../pages/landing/RealtorLanding"));
const Team = lazy(() => import("../pages/landing/Team"));
//const Property = lazy(() => import("../pages/landing/Property/Property"));
const Property = lazy(() => import("../pages/landing/property"));
const PropertyDetail = lazy(() => import("../pages/landing/property/PropertyDetail"));

const About = lazy(() => import("../pages/about"));
const ContactUs = lazy(() => import("../pages/contact"));
const Blog = lazy(() => import("../pages/blog"));
const BlogDetails = lazy(() => import("../pages/blog/BlogDetails"));
const RentPage = lazy(() => import("../pages/rent"));
const RentDetails = lazy(() => import("../pages/rent/RentDetails"));

const Login = lazy(() => import("../pages/login"));
const Signup = lazy(() => import("../pages/signup"));
const BuyerSignup = lazy(() => import("../pages/buyer"));
const Otp = lazy(() => import("../pages/signup/OTP"));
const ForgotPassword = lazy(() => import("../pages/forgotpassword"));
const ResetPassword = lazy(() => import("../pages/resetpassword"));


const AdminLogin = lazy(() => import("../pages/adminlogin"));
const AdminDashboard = lazy(() => import("../pages/admin/dashboard"));
const AdminProperty = lazy(() => import("../pages/admin/property"));
const AdminUsers = lazy(() => import("../pages/admin/users"));
const AdminKycStatus = lazy(() => import("../pages/admin/kyc_status"));
const AdminSetting = lazy(() => import("../pages/admin/setting"));
const AdminPropertyDetail = lazy(() => import("../pages/admin/property/PropertyDetails"));

const AdminDealRoom = lazy(() => import("../pages/admin/deal_room"));
const AdminDealRoomDetail = lazy(() => import("../pages/admin/deal_room/Detail"));

const UserDashboard = lazy(() => import("../pages/user/dashboard"));
const UserKyc = lazy(() => import("../pages/user/kyc"));
const UserProperty = lazy(() => import("../pages/user/property"));
const UserAddProperty = lazy(() => import("../pages/user/property/AddProperty"));
const UserPropertyDetail = lazy(() => import("../pages/user/property/PropertyDetails"));
const UserMessage = lazy(() => import("../pages/user/message"));
const UserSetting = lazy(() => import("../pages/user/setting"));
const UserEditProperty = lazy(() => import("../pages/user/property/EditPropertyPage"));

const UserManagementDetails = lazy(() => import("../pages/user/property/UserManagementDetails"));

const UserNotifications = lazy(() => import("../pages/user/notifications"));
//const UserNotificationDetails = lazy(() => import("../pages/user/notifications/NotificationDetails"));

const Listing = lazy(() => import("../pages/listing"));
const Events = lazy(() => import("../pages/event"));





const RouterConfig = () => {

  return (
    <Suspense
    //fallback={<Loader />}
    >
      <Routes>
        <Route path={Path.Landing} element={<Landing />} />

        <Route path={Path.Realtor} element={<Realtor />} />
        <Route path={Path.Landlord} element={<Landlord />} />
        <Route path={Path.Lawyer} element={<Lawyer />} />
        <Route path={Path.Agent} element={<Agent />} />
        <Route path={Path.Team} element={<Team />} />

        <Route path={Path.Home} element={<Home />} />
        <Route path={Path.ContactUs} element={<ContactUs />} />
        <Route path={Path.About} element={<About />} />
        <Route path={Path.Listing} element={<Listing />} />
        <Route path={Path.Events} element={<Events />} />

        <Route path={Path.Login} element={<Login />} />
        <Route path={Path.AdminLogin} element={<AdminLogin />} />
        {/* <Route path={Path.AdminDashboard} element={<AdminDashboard />} />
        <Route path={Path.AdminProperty} element={<AdminProperty />} />
        <Route path={Path.AdminUsers} element={<AdminUsers />} /> */}


        <Route path={Path.Signup} element={<Signup />} />
        <Route path={Path.Buyer} element={<BuyerSignup />} />
        <Route path={Path.Otp} element={<Otp />} />
        <Route path={Path.ForgotPassword} element={<ForgotPassword />} />
        <Route path={Path.ResetPassword} element={<ResetPassword />} />

        {/* <Route path={Path.Property} element={<Property properties={[]} />} /> */}

        <Route path={Path.Property} element={<Property />} />
        <Route path={Path.PropertyDetail} element={<PropertyDetail />} />
        <Route path="/accept-assignment" element={<AcceptAssignment />} />

        <Route
          path={Path.UserDashboard}
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserKyc}
          element={
            <ProtectedRoute>
              <UserKyc />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserProperty}
          element={
            <ProtectedRoute>
              <UserProperty />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserPropertyDetail}
          element={
            <ProtectedRoute>
              <UserPropertyDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserNotifications}
          element={
            <ProtectedRoute>
              <UserNotifications />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserManagementDetails}
          element={
            <ProtectedRoute>
              <UserManagementDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserPropertyDetail}
          element={
            <ProtectedRoute>
              <UserPropertyDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserEditProperty}
          element={
            <ProtectedRoute>
              <UserEditProperty />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserMessage}
          element={
            <ProtectedRoute>
              <UserMessage />
            </ProtectedRoute>
          }
        />
        <Route
          path={Path.UserDealRoom}
          element={
            <ProtectedRoute>
              <DealRoom />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserDealRoomDetail}
          element={
            <ProtectedRoute>
              <DealRoomDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path={Path.UserSetting}
          element={
            <ProtectedRoute>
              <UserSetting />
            </ProtectedRoute>
          }
        />
        {/* <Route path={Path.UserDashboard} element={<UserDashboard />} /> */}

        {/* ADMIN ROUTE */}
        <Route
          path={Path.AdminDashboard}
          element={
            <AdminProtectedRoute>
              <AdminDashboard />
            </AdminProtectedRoute>
          }
        />

        <Route
          path={Path.AdminProperty}
          element={
            <AdminProtectedRoute>
              <AdminProperty />
            </AdminProtectedRoute>
          }
        />

        <Route
          path={Path.AdminPropertyDetail}
          element={
            <AdminProtectedRoute>
              <AdminPropertyDetail />
            </AdminProtectedRoute>
          }
        />

        <Route
          path={Path.AdminUsers}
          element={
            <AdminProtectedRoute>
              <AdminUsers />
            </AdminProtectedRoute>
          }
        />

        <Route
          path={Path.AdminSetting}
          element={
            <AdminProtectedRoute>
              <AdminSetting />
            </AdminProtectedRoute>
          }
        />

        <Route
          path={Path.AdminKycStatus}
          element={
            <AdminProtectedRoute>
              <AdminKycStatus />
            </AdminProtectedRoute>
          }
        />

        <Route
          path={Path.AdminDealRoom}
          element={
            <AdminProtectedRoute>
              <AdminDealRoom />
            </AdminProtectedRoute>
          }
        />

          <Route
          path={Path.AdminDealRoomDetail}
          element={
            <AdminProtectedRoute>
              <AdminDealRoomDetail />
            </AdminProtectedRoute>
          }
        />





        <Route path={Path.Blog} element={<Blog />} />
        <Route path={Path.BlogDetail} element={<BlogDetails />} />
        <Route path={Path.RentPage} element={<RentPage />} />
        <Route path={Path.RentDetail} element={<RentDetails />} />


        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )

}

export default RouterConfig;